import React from 'react';
import { Box, Grid, Skeleton, styled } from '@mui/material';

const StyledCard = styled(Box)(({ theme }) => ({
    background: theme.palette.background.default,
    padding: '24px',
    borderRadius: '16px',
    boxShadow: '0px 4px 80px 0px rgba(112,144,176,0.14)',
    height: '100%',
}));

export const TalentPreviewSkeleton = () => {
    return (
        <>
            {/* Banner Skeleton */}
            <Skeleton
                variant="rectangular"
                sx={{
                    width: '100%',
                    height: '100px',
                    borderRadius: '16px',
                    marginBottom: '14px',
                }}
            />

            <Grid container spacing="14px">
                {/* Profile Header Skeleton */}
                <Grid item xs={8}>
                    <StyledCard sx={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '32px 16px' }}>
                        {/* Top Section */}
                        <Box sx={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                            <Skeleton variant="circular" width={80} height={80} />
                            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                    <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: '16px' }} />
                                    <Skeleton variant="text" width="50%" height={20} />
                                </Box>
                                <Skeleton variant="text" width="40%" height={32} />
                                <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                    <Skeleton variant="text" width={80} height={20} />
                                    <Skeleton variant="circular" width={4} height={4} />
                                    <Skeleton variant="text" width={100} height={20} />
                                </Box>
                            </Box>
                        </Box>

                        {/* Tags Skeleton */}
                        <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            {[1, 2, 3].map(i => (
                                <Skeleton
                                    key={i}
                                    variant="rounded"
                                    width={120}
                                    height={32}
                                    sx={{ borderRadius: '16px' }}
                                />
                            ))}
                        </Box>

                        {/* Availability Skeleton */}
                        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <Skeleton variant="circular" width={20} height={20} />
                            <Skeleton variant="text" width="60%" height={20} />
                        </Box>
                    </StyledCard>
                </Grid>

                {/* Contact Info Skeleton */}
                <Grid item xs={4}>
                    <StyledCard sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <Skeleton variant="text" width="50%" height={24} />
                        {[1, 2, 3, 4, 5, 6].map(i => (
                            <Box key={i} sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <Skeleton variant="circular" width={24} height={24} />
                                <Skeleton variant="text" width="70%" height={20} />
                            </Box>
                        ))}
                    </StyledCard>
                </Grid>

                {/* Bio Skeleton */}
                <Grid item xs={12}>
                    <StyledCard>
                        <Skeleton variant="text" width="30%" height={24} sx={{ marginBottom: '16px' }} />
                        <Skeleton variant="text" width="100%" height={16} />
                        <Skeleton variant="text" width="100%" height={16} />
                        <Skeleton variant="text" width="80%" height={16} />
                    </StyledCard>
                </Grid>

                {/* Salary Skeleton */}
                <Grid item xs={12}>
                    <StyledCard>
                        <Skeleton variant="text" width="30%" height={24} sx={{ marginBottom: '16px' }} />
                        <Box sx={{ display: 'flex', gap: '32px' }}>
                            <Box sx={{ flex: 1 }}>
                                <Skeleton variant="text" width="60%" height={20} sx={{ marginBottom: '8px' }} />
                                <Skeleton variant="text" width="40%" height={32} />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <Skeleton variant="text" width="60%" height={20} sx={{ marginBottom: '8px' }} />
                                <Skeleton variant="text" width="40%" height={32} />
                            </Box>
                        </Box>
                    </StyledCard>
                </Grid>

                {/* Experience Skeleton */}
                <Grid item xs={12}>
                    <StyledCard>
                        <Skeleton variant="text" width="30%" height={24} sx={{ marginBottom: '16px' }} />
                        {[1, 2].map(i => (
                            <Box key={i} sx={{ marginBottom: '24px' }}>
                                <Skeleton variant="text" width="40%" height={20} sx={{ marginBottom: '12px' }} />
                                <Box sx={{ paddingLeft: '24px' }}>
                                    <Skeleton variant="text" width="50%" height={20} sx={{ marginBottom: '8px' }} />
                                    <Skeleton variant="text" width="100%" height={16} />
                                    <Skeleton variant="text" width="90%" height={16} />
                                </Box>
                            </Box>
                        ))}
                    </StyledCard>
                </Grid>

                {/* Skills Skeleton */}
                <Grid item xs={6}>
                    <StyledCard>
                        <Skeleton variant="text" width="40%" height={24} sx={{ marginBottom: '16px' }} />
                        <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            {[1, 2, 3, 4, 5].map(i => (
                                <Skeleton
                                    key={i}
                                    variant="rounded"
                                    width={100}
                                    height={32}
                                    sx={{ borderRadius: '16px' }}
                                />
                            ))}
                        </Box>
                    </StyledCard>
                </Grid>

                <Grid item xs={6}>
                    <StyledCard>
                        <Skeleton variant="text" width="40%" height={24} sx={{ marginBottom: '16px' }} />
                        <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            {[1, 2, 3, 4, 5].map(i => (
                                <Skeleton
                                    key={i}
                                    variant="rounded"
                                    width={110}
                                    height={32}
                                    sx={{ borderRadius: '16px' }}
                                />
                            ))}
                        </Box>
                    </StyledCard>
                </Grid>
            </Grid>
        </>
    );
};
